import { Transition } from "@headlessui/react";
import { ButtonType } from "immigram-ui-cmon/src/components/Button/Button";
import Button from "immigram-ui-cmon/src/components/Button/Button";
import Dropdown, {
  DropdownOption,
} from "immigram-ui-cmon/src/components/Dropdown/Dropdown";
import { Icon24Menu } from "immigram-ui-cmon/src/components/Icons";
import { useOutsideEvent } from "immigram-ui-cmon/src/hooks";
import { useTranslation } from "next-i18next";
import React, { useCallback, useMemo, useRef, useState } from "react";

interface ProfessionalJourneyMenuProps {
  onDelete?: () => void;
  onGenerateDoc?: () => void;
  onGenerateChecklist?: () => void;
}

enum Actions {
  Delete = "delete",
  GenerateDoc = "generateDoc",
  GenerateChecklist = "generateChecklist",
}

export default function ProfessionalJourneyMenu({
  onDelete,
  onGenerateDoc,
  onGenerateChecklist,
}: ProfessionalJourneyMenuProps) {
  const { t } = useTranslation();
  const [isOpened, setIsOpened] = useState(false);
  const element = useRef<HTMLDivElement | null>(null);

  useOutsideEvent(element, () => {
    setIsOpened(false);
  });

  const options: DropdownOption[] = useMemo(
    () => [
      ...(onDelete
        ? [
            {
              title: t(
                "application:profJourney.new.ProfessionalJourneyMenu.item.delete"
              ),
              value: Actions.Delete,
            },
          ]
        : []),

      ...(onGenerateDoc
        ? [
            {
              title: t(
                "application:profJourney.new.ProfessionalJourneyMenu.item.generateDoc"
              ),
              value: Actions.GenerateDoc,
            },
          ]
        : []),

      ...(onGenerateChecklist
        ? [
            {
              title: t(
                "application:profJourney.new.ProfessionalJourneyMenu.item.generatecChecklist"
              ),
              value: Actions.GenerateChecklist,
            },
          ]
        : []),
    ],
    [onDelete, onGenerateDoc, onGenerateChecklist, t]
  );

  const handleSelect = useCallback(
    (option: DropdownOption) => {
      if (option.value === Actions.Delete) {
        onDelete?.();
      }
      if (option.value === Actions.GenerateChecklist) {
        onGenerateChecklist?.();
      }
      if (option.value === Actions.GenerateDoc) {
        onGenerateDoc?.();
      }
    },
    [onDelete, onGenerateChecklist, onGenerateDoc]
  );

  const handleOpen = useCallback(
    (e: React.MouseEvent<Element>) => {
      e.stopPropagation();
      setIsOpened(true);
    },
    [setIsOpened]
  );

  if (!options.length) {
    return null;
  }

  return (
    <div className="relative" ref={element}>
      <Button
        icon={<Icon24Menu />}
        type={ButtonType.Secondary}
        size="200"
        onClick={handleOpen}
      />
      <Transition
        show={isOpened}
        enter="transition-opacity duration-200"
        enterFrom="opacity-100"
        enterTo="opacity-100"
        leave="transition-opacity duration-200"
        leaveFrom="opacity-100"
        leaveTo="opacity-100 hidden"
      >
        <Dropdown
          className="w-64 overflow-y-scroll"
          options={options}
          onSelect={handleSelect}
          position="top-left"
        ></Dropdown>
      </Transition>
    </div>
  );
}
